/* LITCHI cart-drawer deals: tab switching, price-ordered products, add-to-cart with deal tag. */
(() => {
  // Products are rendered lowest price first (Liquid); just scroll each row back to the start.
  const resetRows = () => {
    document.querySelectorAll('[data-litchi-deal-row]').forEach((row) => {
      row.scrollLeft = 0;
    });
  };

  // Keep the deal message on one line: shrink the font (13px → 8.5px) until it fits.
  const fitMsg = (msg) => {
    if (!msg || !msg.clientWidth) return;
    let size = 13;
    msg.style.fontSize = `${size}px`;
    while (msg.scrollWidth > msg.clientWidth && size > 8.5) {
      size -= 0.25;
      msg.style.fontSize = `${size}px`;
    }
  };
  const fitAll = () => document.querySelectorAll('[data-litchi-deal-msg]').forEach(fitMsg);

  const selectTab = (wrap, deal) => {
    const active = Number(wrap.dataset.activeDeal);
    const count = Number(wrap.dataset.dealCount);
    const msg = wrap.querySelector('[data-litchi-deal-msg]');
    wrap.querySelectorAll('[data-litchi-deal-tab]').forEach((tab) => {
      tab.classList.toggle('is-selected', Number(tab.dataset.litchiDealTab) === deal);
    });
    const locked = deal > active;
    wrap.classList.toggle('litchi-deals--viewing-locked', locked);
    if (!msg || active > count) return;
    if (locked) {
      msg.innerHTML = `Add a <strong>Deal ${deal - 1}</strong> item to unlock <strong>Deal ${deal}</strong>`;
    } else if (deal < active) {
      msg.innerHTML = `<strong>Deal ${deal} claimed ✓</strong> Pick Deal ${active} below`;
    } else {
      msg.innerHTML = msg.dataset.original || msg.innerHTML;
    }
    fitMsg(msg);
  };

  // Deal copies left in a cart that may no longer have them (no regular item, or wallet credit
  // applied) are listed by the snippet; swap each back to its full-price original.
  let swapping = false;
  const swapBackDealCopies = async () => {
    const el = document.querySelector('[data-litchi-deal-swap]');
    if (!el || swapping) return;
    let lines;
    try { lines = JSON.parse(el.textContent); } catch (e) { return; }
    if (!lines.length) return;
    swapping = true;
    try {
      const root = window.Shopify.routes.root;
      const updates = {};
      lines.forEach((l) => { updates[l.key] = 0; });
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines.map((l) => ({ id: l.id, quantity: l.quantity })) })
      });
    } catch (e) {
      // leave the cart as it is; the order-side check flags anything that slips through
    }
    swapping = false;
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  };

  const init = () => {
    document.querySelectorAll('[data-litchi-deal-msg]').forEach((msg) => {
      msg.dataset.original = msg.innerHTML;
    });
    resetRows();
    fitAll();
    swapBackDealCopies();
  };

  // "Complete the look": add an Add button on each recommended product's image.
  // The recommendations are fetched into the drawer after it opens, so watch for them.
  const addUpsellButtons = () => {
    document.querySelectorAll('.cart-drawer .cart-item-upsells product-block').forEach((block) => {
      const cont = block.querySelector('.image-cont');
      const link = block.querySelector('a.product-link');
      if (!cont || !link || cont.querySelector('.litchi-upsell-add')) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'litchi-upsell-add';
      btn.dataset.productUrl = new URL(link.href, window.location.origin).pathname;
      btn.textContent = 'Add';
      cont.appendChild(btn);
    });
  };

  const addUpsellToCart = async (btn) => {
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    try {
      const product = await (await fetch(`${btn.dataset.productUrl}.js`)).json();
      // Products with real options (sizes etc.) go to the product page rather than guessing a variant.
      if (product.variants.length > 1) {
        window.location.href = btn.dataset.productUrl;
        return;
      }
      const variant = product.variants.find((v) => v.available);
      if (!variant) throw new Error('sold out');
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      if (!res.ok) throw new Error(res.status);
      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } catch (e) {
      btn.textContent = e.message === 'sold out' ? 'Sold out' : 'Try again';
      btn.removeAttribute('aria-disabled');
    }
    btn.classList.remove('is-loading');
  };

  document.addEventListener('click', async (evt) => {
    const upsellBtn = evt.target.closest('.litchi-upsell-add');
    if (upsellBtn) {
      evt.preventDefault();
      evt.stopPropagation();
      if (upsellBtn.getAttribute('aria-disabled') !== 'true') addUpsellToCart(upsellBtn);
      return;
    }

    const tab = evt.target.closest('[data-litchi-deal-tab]');
    if (tab) {
      selectTab(tab.closest('[data-litchi-deals]'), Number(tab.dataset.litchiDealTab));
      return;
    }

    const btn = evt.target.closest('[data-litchi-deal-add]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    const wrap = btn.closest('[data-litchi-deals]');
    if (wrap.classList.contains('litchi-deals--viewing-locked')) return;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(btn.dataset.variantId),
            quantity: 1,
            properties: { _litchi_deal: wrap.dataset.activeDeal }
          }]
        })
      });
      if (!res.ok) throw new Error(res.status);
      btn.querySelector('[data-litchi-deal-add-label]').textContent = 'Added';
    } catch (e) {
      btn.querySelector('[data-litchi-deal-add-label]').textContent = 'Try again';
      btn.removeAttribute('aria-disabled');
    }
    btn.classList.remove('is-loading');
    // Refreshes the drawer (and header cart count) through the theme's own listener.
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  });

  document.addEventListener('on:cart:after-merge', init);
  const watchUpsells = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    addUpsellButtons();
    new MutationObserver(addUpsellButtons).observe(drawer, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchUpsells);
  } else {
    watchUpsells();
  }
  document.addEventListener('on:cart-drawer:before-open', resetRows, true);
  // The drawer is hidden (zero width) until opened, so fit again once it is visible.
  document.addEventListener('on:cart-drawer:after-open', fitAll, true);
  document.addEventListener('on:cart-drawer:before-open', () => setTimeout(fitAll, 60), true);
  window.addEventListener('resize', fitAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
